import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AppComponent } from '../app.component';
import { ApiRestService } from '../services/api-rest.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})


export class RegisterComponent implements OnInit {
	config: any;
	registerForm : FormGroup;
	response = {
      "HasError": true,
      "status": false,
      "success": false,
      "result": {"records":[]},
      "AlertType": "",
      "AlertMessage": "",
      "ModelErrors": [],
      "error": {
        "email": ""
      }
    };
  model = {
    password:"",
    passconfirm:""
  };
    countries=[];
    name:string;
    lastname:string;
    phone:string;
    email:string;
    password:string;
    passconfirm:string;
    currency:string;
    site:string;
    skype:string;
    click : boolean = true;
    currencys = [];
    showError : boolean = false;

  constructor(

  	private appComponent: AppComponent,
  	private apiRestService: ApiRestService,
  	private formBuilder: FormBuilder,
    private router: Router,
    private fb: FormBuilder

  	) {
      this.config = this.appComponent.config;
  }

  ngOnInit(): void {
  	 var vthis = this;
        this.currencys = this.config.currency;

        this.registerForm = this.fb.group({
          name: new FormControl('', [Validators.required]),
          lastname: new FormControl('', [Validators.required]),
          phone: new FormControl('', [Validators.required]),
          email: new FormControl('', [Validators.required]),
          password: new FormControl('', [Validators.required, Validators.minLength(6)]),
          passconfirm: new FormControl('', [Validators.required]),
          currency: new FormControl('', [Validators.required]),
          countryf: new FormControl('', [Validators.required]),
          site: new FormControl(''),
          skype: this.config.partner != 18 && this.config.partner != 15 && this.config.partner != 13  && (this.config.partner == 0 && this.appComponent.country != 'cl') ? new FormControl('', [Validators.required]) : new FormControl(''),
        });

        this.setDefaults();

        if(this.registerForm.valid) {
          vthis.click = false;
        }

        this.apiRestService.request('GetRegions', {
          withCredentials: true
        }, {withCredentials: true}).subscribe((response) => {
          Object.assign(this.response, response);
          console.log(this.response);
          if(this.response.status){
            this.countries = this.response.result.records;
            this.countries.unshift({ Id: "", Name: ""});
            console.log(this.countries);
          }else{
           this.showError = true;
          }
        });
  }

  setDefaults() {
    this.registerForm.get("currency").patchValue(this.config.currency);
  }

  register(){
    var vthis = this;
  		/*console.log(this.model)*/
    if(this.registerForm.valid){
    		var params = {
    		  country: this.config.countryFixed,
  		    name: this.registerForm.value.name,
  		    lastname: this.registerForm.value.lastname,
  		    phone: this.registerForm.value.phone,
  		    email: this.registerForm.value.email,
  		    password: this.registerForm.value.password,
  		    currency: this.registerForm.value.currency,
          countryf: this.registerForm.value.countryf,
          skype: this.registerForm.value.skype,
  		    site: this.registerForm.value.site
    		 }
         const options = {
                    withCredentials: true
                };
    		 console.log(params);
    		 this.apiRestService.request('register', params, options).subscribe((response) => {
    		   Object.assign(this.response, response);
    		   console.log(this.response);
    		   if(this.response.success){
    		        /*this.resetModel();*/
                $('#myModal').modal('show');
                $('#myModal').on('hidden.bs.modal', function (e) {
                     vthis.router.navigate(['/login']);
                 });
    		   }else{
    		     this.showError = true;
             $(window).scrollTop(0);
           }
    		 });
      }
  }

}
